import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconWhiteboard2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"whiteboard-2"} maskId="square-filled-radius-0-stroke-1-IconWhiteboard2"><path d="M12.5 3H11.5V4H2V5H3V19H2V20H22V19H21V5H22V4H12.5V3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconWhiteboard2;
